// The agents space, coming soon: the one call that puts a person on the agent memory list
// (POST /api/me/agent-memory). Two callers share it: the dashboard when the address asked for the
// agents space (it may land somewhere else first, a first-run walk for one), and the room itself when it
// opens. The server is idempotent; this keeps the page from asking twice. A failed ask is forgotten, so
// opening the room again tries once more.

import type { AgentsAsk } from "../../lib/agents/soonAsk";

let asked: Promise<boolean> | null = null;

/** resolves true when the person is on the list (this call or an earlier one), false when it could not be said */
export function joinAgentMemoryList(ask?: AgentsAsk | null): Promise<boolean> {
  if (asked) return asked;
  asked = fetch("/api/me/agent-memory", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(ask ?? {}),
    cache: "no-store",
  })
    .then(async (res) => {
      const json = (await res.json().catch(() => null)) as { ok?: boolean } | null;
      return res.ok && json?.ok === true;
    })
    .catch(() => false)
    .then((ok) => {
      if (!ok) asked = null;
      return ok;
    });
  return asked;
}
